// google maps api key for 'dev'

if (ENV === 'production') {
  global.disableTracking = false;
  global.googleApiKey = 'AIzaSyAgkJ5RUqarPPKo9HWY3_OhpDGIBWznKLU';
} else {
  global.disableTracking = false;
  global.googleApiKey = 'AIzaSyDoHAKmV2ShZUczZhFd7lLx9uiMln0eOd8';
}
